import axios from "axios";
// import Swal from "sweetalert2";
const state = {};
const mutations = {};
const actions = {
  async cargarPuertos(_, data) {
    let listado = [];
    var config = {
      method: "get",
      url: process.env.VUE_APP_URL_MAIN + "calc/cargar_puertos",
      headers: {
        "auth-token": sessionStorage.getItem("auth-token"),
        "Content-Type": "application/json",
      },
      params: data,
    };
    await axios(config)
      .then(function (response) {
        let data = response.data;
        if (data.estadoflag) {
          listado = data.data;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    return listado;
  },
  async cargarPaises(_, data) {
    let listado = [];
    var config = {
      method: "get",
      url: process.env.VUE_APP_URL_MAIN + "calc/cargar_paises",
      headers: {
        "auth-token": sessionStorage.getItem("auth-token"),
        "Content-Type": "application/json",
      },
      params: data,
    };
    await axios(config)
      .then(function (response) {
        let data = response.data;
        if (data.estadoflag) {
          listado = data.data;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    return listado;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
